import { AddressOrdersFormValues, AddressType, PatientAddressFormValues } from '../../models';

export class FetchPatientAddresses {
  static readonly type = '[Patient Addresses] Fetch Patient Addresses';
}

export class CreatePatientAddress {
  static readonly type = '[Patient Addresses] Create Patient Address';
  constructor(public formValues: PatientAddressFormValues) {}
}

export class AddPatientAddressType {
  static readonly type = '[Patient Addresses] Set Patient Address Default';
  constructor(public addressId: number, public addressType: AddressType) {}
}

export class FetchPreviousShippingAddressOrdersIfNeeded {
  static readonly type = '[Patient Addresses] Fetch Orders for the Default Shipping Address If Changed';
  constructor(public addressId: number) {}
}

export class UpdateOrdersToDefaultShipping {
  static readonly type = '[Patient Addresses] Update Orders to Use New Default Shipping Address';
  constructor(public formValues: AddressOrdersFormValues) {}
}

export class ClearPreviousShippingAddressOrders {
  static readonly type = '[Patient Addresses] Clear Previous Shipping Addess Orders List';
}
